import { LoaderRow } from "@circle-react-shared/LoaderRow";
import { usePoll } from "@circle-react-shared/uikit/TipTapBlockEditor/PollExtension/PollModal/api";
import { NodeViewWrapper } from "@tiptap/react";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { PollWrapper as PollWrapperCompass } from "./Compass/PollWrapper";
import { PollWrapper } from "./PollWrapper";

export const PollDisplay = ({ node, editor, deleteNode }: any) => {
  const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_modals_enabled");
  const { data: poll, isInitialLoading: isLoading } = usePoll({
    sgid: node.attrs?.sgid,
    options: {
      enabled: !!node.attrs?.sgid,
    },
  });

  const PollWrapperComponent = isCircleV4 ? PollWrapperCompass : PollWrapper;

  return (
    <NodeViewWrapper as="div">
      {isLoading || !poll ? (
        <div className="my-4">
          <LoaderRow />
        </div>
      ) : (
        <PollWrapperComponent
          deleteNode={deleteNode}
          isEditable={editor.isEditable}
          poll={poll}
        />
      )}
    </NodeViewWrapper>
  );
};
